import { render, staticRenderFns } from "./authResources.vue?vue&type=template&id=ac48ddac"
import script from "./authResources.vue?vue&type=script&lang=js"
export * from "./authResources.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports